/**
 * sidebar-sticky.js starts
 * Created by mac on 06.09.2018.
 */

$(function () {
  
  var $sbaffix = $('.sb-section-affix'),
      stickySidebar,
      footer   = document.getElementById('page-footer'),
      sidebar  = document.getElementById('sidebar');
  
  
  if ($sbaffix.length && $sbaffix.is(":visible")) {
    var footerH          = footer.clientHeight,
        sidebarOffset    = sidebar.getBoundingClientRect(),
        sidebarH         = sidebar.clientHeight,
        sidebarOffsetTop = sidebarOffset.top;
  
    stickySidebar = new Waypoint.Sticky({
      element: $sbaffix[0],
      offset: '125px',
      handler: function (dir) {
        console.log('stuck');
      }
    });
    
    var checkSbAffixBottom = function () {
      if (stickySidebar !== undefined) {
        var stickyOffset = stickySidebar.element.getBoundingClientRect().bottom;
        
        if(sidebarOffset < stickyOffset) {
          stickySidebar.element.classList.add('sticky-bottom');
        }
        else {
          stickySidebar.element.classList.remove('sticky-bottom');
        }
      }
    };
    
    $(window).on('scroll', checkSbAffixBottom);
  }
  
});
